import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxLoadingModule } from 'ngx-loading';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-pershing-print',
  templateUrl: './pershing-print.component.html',
  styleUrls: ['./pershing-print.component.scss'],
  imports: [
    MatDialogModule,
    NgxLoadingModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class PershingPrintComponent {
  private rbs = inject(RightBridgeApiService);

  @Input() profile;
  @Input() silentPrint;
  @Input() customDefinition;
  @Input() headline;
  @Input() content;
  @Input() accountTypes;
  @Output() closeDialog = new EventEmitter();

  loading = false;
  rights: string[];
  generating = false;

  Client = {
    BackOfficeRRCode: null,
    BackOfficeOfficeCode: null,
    BackOfficeAccountTypeCode: null,
  };

  cancel() {
    this.closeDialog.emit('cancel');
  }

  generateReport() {
    this.loading = true;
    const saveData = {};
    Object.keys(this.Client).forEach(x => {
      if (x === 'BackOfficeRRCode') {
        saveData[`Client.${x}`] = this.Client[x].toUpperCase();
      } else {
        saveData[`Client.${x}`] = this.Client[x];
      }
    });

    this.rbs.saveProfile(this.profile, saveData, false).subscribe(() => {
      this.closeDialog.emit('continue');
      this.loading = false;
    });
  }
}
